import React from "react";
import styled from "styled-components";

const Maintenance = () => {
    return (
        <Container>
            <div>Maintenance</div>
        </Container>
    );
};

export default Maintenance;

const Container = styled.div`
    color: white;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
`;
